var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',_vm._b({attrs:{"label":_vm.label,"items":_vm.items},on:{"change":function($event){return _vm.$emit('change', $event)},"click:append":function($event){return _vm.$emit('clickappend')}}},'v-select',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }